import {
  Box,
  Button,
  Dialog,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useReport } from "../../contexts/ReportContext";
import { TextInput } from "../inputs";

interface NotesDialogProps {
  onSave?: (notes: string) => void;
}

const NotesDialog: React.FC<NotesDialogProps> = ({ onSave }) => {
  const [notes, setNotes] = useState<string>("");

  const { notesDialogOpen, toggleNotesDialog } = useReport();
  const handleSubmit = () => {
    onSave?.(notes);
    toggleNotesDialog();
  };

  return (
    <Dialog open={notesDialogOpen} onClose={toggleNotesDialog}>
      <Box
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: 400,
          padding: 2,
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
        }}
        noValidate
        autoComplete="off"
      >
        <Typography variant="h6" fontWeight={"bold"}>
          Add Notes
        </Typography>
        <Stack
          direction="column"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <TextInput
            label="Notes (Optional)"
            variant="outlined"
            multiline
            rows={4}
            value={notes}
            onChange={(val: string | number) => setNotes(val as string)}
            inputProps={{ maxLength: 100 }}
            fullWidth
            helperText={`${notes.length}/100`}
          />
        </Stack>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}
        >
          <Button color="whiteButton" onClick={toggleNotesDialog}>
            Cancel
          </Button>
          <Button color="blackButton" onClick={handleSubmit}>
            Save
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default NotesDialog;
